<div id="SL21" class="block black flex-center-v">
    <div class="container">
        <h1 class="headline_02_xl mainTitle">{{package.title001}}</h1>
        <div class="testo-description">
            <div class="body_03_xl_regular subtitle">{{package.subtitle001}}</div>
            
            <ul class="body_03_xl_regular">
                <li *ngFor="let item of package.text001">{{ item }}</li>
            </ul>

            <div class="body_03_xl_regular subtitle" [innerHTML]="package.subtitle002"></div>

            <ul class="body_03_xl_regular">
                <li *ngFor="let item of package.text001">{{ item }}</li>
            </ul>


            <div class="body_03_xl_regular text_call_action" [innerHTML]="package.text002"></div>

            <div class="body_03_xl_regular text_call_action_button" [innerHTML]="package.text004"></div>
            <button class="button-send"><a href="mailto:{{package.email}}">{{package.button}}</a></button>
        </div>
    </div>
</div>
